"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invoice = void 0;
var client_1 = require("./client");
var Enterprise_1 = require("./Enterprise");
var invoice_detail_1 = require("./invoice_detail");
var Invoice = /** @class */ (function () {
    function Invoice(data) {
        this.id = data.id;
        this.client_id = data.client_id;
        this.aib = data.aib;
        this.payment_method = data.payment_method;
        this.status = data.status;
        this.enterprise_id = data.enterprise_id;
        this.discount = data.discount;
        this.created_at = data.created_at;
        if (data.client) {
            this.client = new client_1.Client(data.client);
        }
        if (data.invoice_details) {
            this.details = data.invoice_details.map(function (item) { return new invoice_detail_1.InvoiceDetail(item); });
        }
        if (data.enterprise) {
            this.enterprise = new Enterprise_1.Enterprise(data.enterprise);
        }
    }
    Invoice.prototype.toJson = function () {
        return __assign({}, this);
    };
    return Invoice;
}());
exports.Invoice = Invoice;
